<template>
    <div>
        <div class="backbtn" @click="backgoto"><img :src="backicon"/></div>        
    </div>
</template>

<script>
    export default {
        name:'backbtn',
        data() {
            return {
               backicon:require('../../assets/images/mine_icon_left.png')
            }
        },
        methods:{
            backgoto(){

               this.$router.go(-1)         

            }

        }
    }
</script>

<style scoped>
    .backbtn img{ width:1.8rem;}
</style>


// WEBPACK FOOTER //
// src/components/public/backbtn.vue